/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCrop = createReactComponent("outline", "crop", "IconCrop", [["path", { "d": "M8 5v10a1 1 0 0 0 1 1h10", "key": "svg-0" }], ["path", { "d": "M5 8h10a1 1 0 0 1 1 1v10", "key": "svg-1" }]]);

export { IconCrop as default };
//# sourceMappingURL=IconCrop.mjs.map
